<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar navbar-treid row m-0">
      <div class="col-nav-logo">
        <div class="row">
          <div class="col-9 col-md-12">
            <router-link :to="'/'">
              <span class="navbar-brand"></span>
            </router-link>
          </div>
          <div class="col-3 d-md-none my-auto">
            <button
              class="navbar-toggler text-white border-white"
              type="button"
              data-toggle="collapse"
              data-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="material-icons">menu</span>
            </button>
          </div>
        </div>
      </div>
      <div class="col-nav-center mt-2">
        <div class="col-md-12 d-flex justify-content-center mb-2">
          <div class="row" id="search-container">
            <div class="col-md-10">
              <input
                class="form-control mr-sm-2"
                type="search"
                placeholder="Buscar un producto o servicio..."
                aria-label="Search"
                v-model="titleSearch"
                v-on:keyup.enter="searchProduct"
              />
              <div class="text-right pt-2">
                <input
                  v-model="checkSearchSeller"
                  type="checkbox"
                  class="mr-1"
                />
                <label class="m-0 p-0">Buscar por vendedor</label>
              </div>
            </div>
            <div class="col-md-2" id="container-search-btn">
              <span class="btn btn-treid my-2 my-sm-0" @click="searchProduct"
                >Buscar</span
              >
            </div>
          </div>
        </div>
        <div class="col-md-12 text-center">
          <div
            class="collapse navbar-collapse justify-content-center"
            id="navbarNav"
          >
            <ul class="navbar-nav">
              <li class="nav-item">
                <router-link
                  class="
                    nav-link
                    text-white
                    link-danger-2
                    font-weight-bold
                    text-uppercase
                  "
                  to="/"
                  >Inicio</router-link
                >
              </li>
              <li class="nav-item">
                <div class="nav-link">
                  <span
                    class="
                      dropdown-toggle
                      font-weight-bold
                      text-uppercase
                      cursor-pointer cursor-underline
                    "
                    data-toggle="dropdown"
                    @click="
                      isOpenCategoryProductLi = !isOpenCategoryProductLi;
                      isOpenCategoryServiceLi = false;
                    "
                    >Productos</span
                  >
                  <div
                    class="dropdown-menu"
                    aria-labelledby="navbarDropdownMenuLink"
                    v-bind:class="isOpenCategoryProductLi ? 'show' : ''"
                  >
                    <div class="row">
                      <div class="col-md-12">
                        <hr class="ml-3 mr-3" />
                        <h5 class="text-center text-weight-bold">
                          Categorías de productos
                        </h5>
                        <hr class="ml-3 mr-3" />
                      </div>
                      <div
                        class="col-md-4"
                        v-for="category in categoriesProduct"
                        :key="category._id"
                      >
                        <router-link
                          class="dropdown-item text-capitalize"
                          :to="{
                            name: 'ProductsByCategory',
                            params: {
                              category: category.name
                                .replace(/\-/g, '_')
                                .replace(/\s/g, '-'),
                            },
                          }"
                          >{{ category.name }}</router-link
                        >
                      </div>
                      <div class="col-md-4">
                        <router-link
                          class="dropdown-item"
                          :to="{ name: 'Products' }"
                          >Ver todos</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="nav-item">
                <div class="nav-link">
                  <span
                    class="
                      dropdown-toggle
                      text-white
                      font-weight-bold
                      text-uppercase
                      cursor-pointer cursor-underline
                    "
                    data-toggle="dropdown"
                    @click="
                      isOpenCategoryServiceLi = !isOpenCategoryServiceLi;
                      isOpenCategoryProductLi = false;
                    "
                    >Servicios</span
                  >
                  <div
                    class="dropdown-menu dropdown-servicios"
                    aria-labelledby="navbarDropdownMenuLink"
                    v-bind:class="isOpenCategoryServiceLi ? 'show' : ''"
                  >
                    <div class="row">
                      <div class="col-md-12">
                        <hr class="ml-3 mr-3" />
                        <h5 class="text-center text-weight-bold">
                          Categorías de servicios
                        </h5>
                        <hr class="ml-3 mr-3" />
                      </div>
                      <div
                        class="col-md-4"
                        v-for="category in categoriesService"
                        :key="category._id"
                      >
                        <router-link
                          class="dropdown-item"
                          :to="{
                            name: 'ServicesByCategory',
                            params: {
                              category: category.name.replace(/\s/g, '-'),
                            },
                          }"
                          >{{ category.name }}</router-link
                        >
                      </div>
                      <div class="col-md-4">
                        <router-link class="dropdown-item" to="/servicios"
                          >Ver todos</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="nav-item" :class="canSell ? '' : 'd-none'">
                <router-link
                  class="
                    nav-link
                    text-white
                    link-danger-2
                    font-weight-bold
                    text-uppercase
                  "
                  :to="{ name: 'Sell' }"
                  >Vender</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="
                    nav-link
                    text-white
                    link-danger-2
                    font-weight-bold
                    text-uppercase
                  "
                  to="/mis-datos"
                  >Mi cuenta</router-link
                >
              </li>
              <li class="nav-item" :class="isAdmin ? '' : 'd-none'">
                <router-link
                  class="
                    nav-link
                    text-white
                    link-danger-2
                    font-weight-bold
                    text-uppercase
                  "
                  :to="{ name: 'Dashboard' }"
                  >Panel Admin</router-link
                >
              </li>
              <li class="nav-item">
                <a
                  class="
                    nav-link
                    text-white
                    link-danger-2
                    font-weight-bold
                    text-uppercase
                  "
                  href="https://www.sistemaapple.com.mx/soporte/mis-chats?platform=TREID_BLUE"
                  target="__BLANK"
                  >Ayuda</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="col-nav-right text-center">
        <div
          v-if="auth.jwt"
          class="text-white inline d-flex align-items-center"
        >
          <span style="position: relative">
            <span
              class="material-icons cursor-pointer"
              @click="handleClickNotification"
              >notifications</span
            >
            <span
              v-if="notifications.filter((e) => e.active).length"
              class="bage-cart badge badge-danger cursor-pointer"
              style="left: -10px"
              @click="handleClickNotification"
              >{{
                clickedNotification
                  ? 0
                  : notifications.filter((e) => e.active).length
              }}</span
            >
            <ul
              v-if="showNotification"
              class="list-group notification-ul"
              style="position: absolute; z-index: 3"
            >
              <!-- min-width: 20em; left: -8em  -->
              <li
                class="list-group-item cursor-pointer text-dark text-left"
                v-for="notification in notifications.slice(0, 5)"
                :key="notification._id"
                :class="notification.active ? 'bg-notification-active' : ''"
                @click="viewNotification(notification)"
              >
                <div
                  class="d-flex justify-content-between"
                  v-if="notification.kind == 'SALE'"
                >
                  <span
                    class="material-icons mr-2"
                    :class="notification.active ? 'text-success' : ''"
                    >add_business</span
                  >
                  <span class="text-left pr-2">
                    Tienes una nueva
                    <b>venta</b>, ver resumen de compra
                  </span>
                </div>
                <div
                  class="d-flex justify-content-between"
                  v-if="notification.kind == 'SALE_STATE'"
                >
                  <span
                    class="material-icons mr-2"
                    :class="notification.active ? 'text-success' : ''"
                    >new_releases</span
                  >
                  <span class="text-left pr-2">
                    {{ notification.message }}
                  </span>
                </div>
                <div
                  class="d-flex justify-content-between"
                  v-if="notification.kind == 'BUY'"
                >
                  <span
                    class="material-icons mr-2"
                    :class="notification.active ? 'text-success' : ''"
                    >inventory</span
                  >
                  <span class="text-left pr-2">
                    {{ notification.message }}
                  </span>
                </div>
                <div
                  class="d-flex justify-content-between"
                  v-if="notification.kind == 'PRODUCT'"
                >
                  <span
                    class="material-icons mr-2"
                    :class="notification.active ? 'text-success' : ''"
                    >local_offer</span
                  >
                  <span class="text-left pr-2">
                    {{ notification.message }}
                  </span>
                </div>
                <div
                  class="d-flex justify-content-between"
                  v-if="notification.kind == 'SALE_CHAT'"
                >
                  <span
                    class="material-icons mr-2"
                    :class="notification.active ? 'text-success' : ''"
                    >chat</span
                  >
                  <span class="text-left pr-2"> tienes un chat sin leer </span>
                </div>
                <p class="text-right mb-0 text-secondary pr-2">
                  {{ strToDateString(notification.creationDate) }}
                </p>
              </li>
              <li
                v-if="notifications.length"
                class="
                  list-group-item
                  cursor-pointer
                  text-secondary text-center
                "
                @click="viewMyNotifications()"
              >
                Ver mas
              </li>
              <li
                v-else
                class="
                  list-group-item
                  cursor-pointer
                  text-secondary text-center
                "
              >
                No tienen notificaciones
              </li>
            </ul>
          </span>
          <router-link
            class="
              mr-3
              link-danger-2
              font-weight-bold
              text-uppercase text-white
              ml-4
            "
            to="/mis-datos"
            >{{ auth.username }}</router-link
          >
          <span
            class="
              mr-3
              link-danger-2
              font-weight-bold
              text-uppercase
              cursor-pointer
            "
          >
            <router-link to="/carrito" class="text-reset">
              <span
                class="material-icons icons"
                style="font-size: 16px; top: 2px"
                >shopping_cart</span
              >
              carrito
              <span class="bage-cart badge badge-light">{{
                cart.items.length
              }}</span>
            </router-link>
          </span>
          <select
            class="select-flag form-control br-0"
            name=""
            id=""
            v-model="flagSelected"
            @change="changeFlag"
          >
            <option value="GLO">Global</option>
            <option value="COL">Colombia</option>
            <option value="MEX">Mexico</option>
          </select>
          <span
            class="
              mr-1
              link-danger-2
              font-weight-bold
              text-uppercase
              cursor-pointer
            "
            @click="Logout()"
            >Salir</span
          >
        </div>
        <div v-else class="text-white inline">
          <span class="material-icons icons" style="font-size: 16px; top: 2px"
            >lock</span
          >
          <span class="mr-1 ml-1 link-danger-2 cursor-pointer">
            <router-link class="text-white" to="/login"
              >Iniciar Sesión</router-link
            > </span
          >o
          <span class="ml-1 link-danger-2 cursor-pointer">
            <router-link class="text-white" to="/sistemaapple"
              >Registrarse</router-link
            >
          </span>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Api from "../tools/Api2";
export default {
  name: "NavbarMain",
  data() {
    return {
      checkSearchSeller: false,
      flagSelected: "GLO",
      showNotification: false,
      categoriesProduct: [],
      isOpenCategoryProductLi: false,
      categoriesService: [],
      isOpenCategoryServiceLi: false,
      titleSearch: "",
      notifications: [],
      clickedNotification: false,
    };
  },
  computed: {
    ...mapState(["auth", "cart", "flag"]),
    isAdmin: function() {
      return this.auth.userType > 0;
    },
    canSell: function() {
      return this.auth.posicion != "Usuario";
    },
  },
  methods: {
    ...mapMutations(["deleteAuth", "setFlag"]),
    changeFlag() {
      this.setFlag(this.flagSelected);
      location.reload();
    },
    viewMyNotifications() {
      this.$router.push({ name: "MyNotifications" });
    },
    handleClickNotification() {
      this.showNotification = !this.showNotification;
      this.co;
      Api("notification")
        .patch("", {})
        .then(() => {
          this.clickedNotification = true;
        });
    },
    viewNotification(notification) {
      // eslint-disable-next-line no-unused-vars
      const { _id, ...notificationPatch } = notification;
      Api("notification")
        .patch(notification._id, { ...notificationPatch, active: false })
        .then(() => {
          switch (notification.kind) {
            case "BUY":
              this.$router.push(`/mi-compra/${notification.props.sale}`);
              break;
            case "SALE":
              this.$router.push(`/mi-venta/${notification.props.sale}`);
              break;
            case "PRODUCT":
              if (notification.props.state == 1) {
                this.$router.push(
                  `/producto/${notification.props.product}/${notification.props.name}`
                );
              } else {
                this.$router.push(
                  `/seller/publication/${notification.props.product}/${notification.props.name}`
                );
              }

              break;
            case "SALE_CHAT":
              this.$router.push(
                `/mi-${
                  notification.props.kind == "seller" ? "compra" : "venta"
                }/${notification.message}`
              );
              break;
            case "SALE_STATE":
              this.$router.push(`/mi-compra/${notification.props.sale}`);
              break;
            default:
              break;
          }
        });
    },
    strToDateString(str) {
      let date = new Date(str);
      return `${date.getDate()}.${(date.getMonth() < 10 ? "0" : "") +
        date.getMonth()}.${date.getFullYear()} a las ${date.getHours()}:${date.getMinutes()}`;
    },
    Logout() {
      this.deleteAuth();
      this.$route.path !== "/" ? this.$router.push("/") : false;
    },
    searchProduct() {
      if (this.titleSearch == "") {
        return;
      }
      if (
        this.$route.path ==
        `/search/${this.titleSearch.replace(/\s/g, "-")}${
          this.checkSearchSeller ? "?seller=true" : ""
        }`
      ) {
        this.$router.go(this.$router.currentRoute);
        return;
      }
      this.$router.push(
        `/search/${this.titleSearch.replace(/\s/g, "-")}${
          this.checkSearchSeller ? "?seller=true" : ""
        }`
      );
    },
  },
  created: function() {
    if (this.$route.name == "Login") return;
    Api("category?filter[kind]=producto")
      .get()
      .then((res) => {
        this.categoriesProduct = res.categories;
      });

    Api("category?filter[kind]=servicio")
      .get()
      .then((res) => {
        this.categoriesService = res.categories;
      });

    if (this.auth.jwt)
      Api("notification")
        .get()
        .then((res) => {
          if (res.error) {
            return;
          }
          this.notifications = res.notifications.slice(0, 6);
        });

    if (this.flag == "xx") {
      Api("sistem-apple")
        .get("my-country")
        .then((res) => {
          this.setFlag(res.geo);
          this.flagSelected = res.geo;
        });
    } else {
      this.flagSelected = this.flag;
    }
  },
};
</script>

<style lang="sass">
.select-flag, .select-flag:focus
  height: 32px
  width: 110px
  padding: 0
  margin-right: 0.5em
  background-color: #162b46
  color: #E7E6E6
  box-shadow: none
  border: #fff

.flag
  width: 32px
  height: 20px
  border-radius: 0.1em
  position: absolute

.flag.active
  border: 2px solid black

.flag-gl
  background: url("../assets/flags/gl-flag.gif")
  background-position: center
  background-size: cover

.flag-ar
  background: url("../assets/flags/ar-flag.gif")
  background-position: center
  background-size: cover

.flag-bl
  background: url("../assets/flags/bl-flag.gif")
  background-position: center
  background-size: cover

.flag-cl
  background: url("../assets/flags/ci-flag.gif")
  background-position: center
  background-size: cover

.flag-co
  background: url("../assets/flags/co-flag.gif")
  background-position: center
  background-size: cover

.flag-mx
  background: url("../assets/flags/mx-flag.gif")
  background-position: center
  background-size: cover

.flag-pe
  background: url("../assets/flags/pe-flag.gif")
  background-position: center
  background-size: cover

.flag-us
  background: url("../assets/flags/us-flag.gif")
  background-position: center
  background-size: cover

.bage-cart
  position: relative
  top: -12px
  left: -3px

.navbar-brand
  background-image: url("../assets/logo_treid.png")
  background-repeat: no-repeat
  background-size: cover
  height: 4em
  width: 10em

.link-danger-2
  &:hover
    text-decoration: underline
.navbar-treid
  background-color: #162b46
  color: #E7E6E6
  font-size: 14px

.btn-treid
  color: white
  background-color: #295da7
  border-color: #295da7

.btn-treid
  color: white
  background-color: #295da7
  border-color: #295da7

  &:hover
    color: #e7e6e6

.cursor-pointer
  cursor: pointer

.cursor-underline
  &:hover
    text-decoration: underline
</style>

<style scoped>
/* COL  */
@media (min-width: 1700px) {
  .col-nav-logo {
    flex: 0 0 16%;
    max-width: 16%;
    display: block;
  }

  .col-nav-center {
    flex: 0 0 59%;
    max-width: 59%;
  }

  .col-nav-right {
    flex: 0 0 25%;
    max-width: 25%;
  }
}

@media (min-width: 1400px) and (max-width: 1699px) {
  .col-nav-logo {
    flex: 0 0 10%;
    max-width: 10%;
    display: block;
  }

  .col-nav-center {
    flex: 0 0 60%;
    max-width: 60%;
  }

  .col-nav-right {
    flex: 0 0 30%;
    max-width: 30%;
  }
}

@media (min-width: 1000px) and (max-width: 1399px) {
  .col-nav-logo {
    flex: 0 0 0%;
    max-width: 00%;
    display: none;
  }

  .col-nav-center {
    flex: 0 0 55%;
    max-width: 55%;
  }

  .col-nav-right {
    flex: 0 0 45%;
    max-width: 45%;
  }
}

@media (min-width: 766px) and (max-width: 999px) {
  .col-nav-logo {
    flex: 0 0 0%;
    max-width: 00%;
    display: none;
  }

  .col-nav-center {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .col-nav-right {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

@media (min-width: 0px) and (max-width: 765px) {
  .col-nav-logo {
    flex: 0 0 100%;
    max-width: 100%;
    display: block;
  }

  .col-nav-center {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .col-nav-right {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

/*min-width: 20em; left: -8em*/
@media (min-width: 768px) {
  .notification-ul {
    width: 20em;
    left: -9em;
  }
}
@media (max-width: 767px) {
  .notification-ul {
    width: 20em;
  }
}
@media (max-width: 720px) {
  #container-search-btn {
    text-align: center !important;
  }

  .dropdown-menu {
    width: 100% !important;
  }
}

@media (min-width: 720px) {
  #search-container {
    width: 75%;
  }

  .dropdown-menu {
    left: 50% !important;
    right: auto !important;
    text-align: center !important;
    transform: translate(-50%, 0) !important;
    min-width: 70em !important;
  }
}

.bg-notification-active {
  background: #f4fbff;
}

.list-group-item:hover {
  background-color: #f2f2f2;
}
.bg-notification-active:hover {
  background-color: #dceffa;
}
</style>
